// extracted by mini-css-extract-plugin
module.exports = {"Container":"Background_Container__2c45N","Desktop":"Background_Desktop__1gHXo","Left":"Background_Left__3FMu1","Right":"Background_Right__3f2LY"};